import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { PilotCharge } from "../utils/types/pilotCharge";

export const fetchPilotChargeList = async () => {
  const response = await axiosServices.get(`/pilotcharge`);
  return convertToCamelCase<PilotCharge[]>(response.data.data);
};

export const updatePilotChargeData = async (
  id: string,
  data: {
    [key: string]: any;
    pilotChargeId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/pilotcharge/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deletePilotChargeData = async (id: string) => {
  const response = await axiosServices.delete(`/pilotcharge/${id}`);
  return { success: response.data.success, id };
};

export const addPilotChargeData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/pilotcharge`, inputData);
  return convertToCamelCase<PilotCharge>(response.data.data);
};
